import * as Effect from 'effect/Effect';
import * as Context from 'effect/Context';
import * as Layer from 'effect/Layer';
import { pipe } from 'effect/Function';
import { ApiClient } from '@/api/client';
import { ApiKeyResponseSchema, UserSchema, type User, type ApiKeyResponse } from '@/api/schemas/user.schema';

export interface UpdateUserRequest {
  name?: string;
  email?: string;
}

export class UserService extends Context.Tag('UserService')<
  UserService,
  {
    readonly updateProfile: (userId: string, data: UpdateUserRequest) => Effect.Effect<User, any>;
    readonly getProfile: (userId: string) => Effect.Effect<User, any>;
    readonly getApiKey: () => Effect.Effect<ApiKeyResponse, any>;
    readonly rotateApiKey: () => Effect.Effect<ApiKeyResponse, any>;
  }
>() {}

export const UserServiceLive = Layer.effect(
  UserService,
  Effect.gen(function* (_) {
    const api = yield* _(ApiClient);

    return {
      updateProfile: (userId, data) =>
        pipe(
          api.put(`/users/${userId}`, data, UserSchema),
          Effect.tap(() => Effect.log(`User profile updated: ${userId}`))
        ),

      getProfile: (userId) =>
        pipe(
          api.get(`/users/${userId}`, UserSchema),
          Effect.tap(() => Effect.log(`User profile fetched: ${userId}`))
        ),

      getApiKey: () =>
        pipe(
          api.get('/users/me/api-key', ApiKeyResponseSchema),
          Effect.tap(() => Effect.log('Fetched API key'))
        ),

      rotateApiKey: () =>
        pipe(
          api.post('/users/me/api-key/rotate', {}, ApiKeyResponseSchema),
          Effect.tap(() => Effect.log('Rotated API key'))
        ),
    };
  })
);
